import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { Withdrawal } from './types'
import { $params } from '../../../../features/router'

export const withdrawalMounted = createEvent()
export const setWithdrawal = createEvent<Withdrawal>()
export const $withdrawal = restore(setWithdrawal, {
  transactionId: '',
  client: {
    clientId: '',
    email: '',
    fullName: '',
    partner: false,
  },
  formData: {
    amount: '',
    toBankAccountName: '',
    toBankAccountNumber: '',
  },
  isAuto: false,
  processingProvider: '',
  processingMethod: '',
  status: '',
  initialAmount: '',
  initialCurrency: '',
  clientAmount: '',
  companyAmount: '',
  exchangeRate: '',
  clientCurrency: '',
  clientCommission: '',
  companyCommission: '',
  commissionCurrency: '',
  createdAt: '',
  updatedAt: '',
  externalId: '',
  providerId: '',
  psId: '',
  clientPurseId: '',
  manager: {
    userId: '',
  },
})

export const getWithdrawal = fx<void, Withdrawal>({
  method: 'GET',
  url: '/transaction_request/',
})

sample({
  clock: withdrawalMounted,
  source: $params,
  fn: (params) => {
    let id
    if (params) {
      id = params.withdrawalID
    }
    return {
      url: `/transaction_request/${id}`,
    }
  },
  target: getWithdrawal,
})

sample({
  clock: getWithdrawal.doneData,
  fn: (doneData) => doneData.body,
  target: setWithdrawal,
})
